function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M23.13 28.002a5.346 5.346 0 0 1-5.34-5.34 5.346 5.346 0 0 1 5.34-5.341 5.346 5.346 0 0 1 5.34 5.34 5.346 5.346 0 0 1-5.34 5.34zm0-13.656c-4.586 0-8.316 3.73-8.316 8.316 0 4.585 3.73 8.315 8.315 8.315 4.586 0 8.317-3.73 8.317-8.316 0-4.585-3.731-8.315-8.317-8.315z",
  clipRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M36.316 29.464c0 1.987-.61 3.635-1.767 4.764-1.146 1.119-2.8 1.71-4.782 1.71H16.492c-1.934 0-3.57-.596-4.731-1.723-1.19-1.154-1.818-2.823-1.818-4.825V16.04c0-1.972.602-3.615 1.741-4.749 1.136-1.129 2.772-1.725 4.734-1.725H29.84c1.95 0 3.586.61 4.732 1.766 1.14 1.148 1.743 2.777 1.743 4.708v13.424zm.369-20.228C34.968 7.506 32.6 6.59 29.84 6.59H16.42c-5.653 0-9.451 3.797-9.451 9.45v13.35c0 2.825.94 5.232 2.721 6.96 1.728 1.677 4.081 2.564 6.804 2.564h13.274c2.775 0 5.147-.885 6.861-2.558 1.742-1.702 2.663-4.085 2.663-6.892V16.04c0-2.733-.9-5.086-2.606-6.804z",
  clipRule: "evenodd"
});

var SvgInst = function SvgInst(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInst, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inst.4ee7048b.svg";
export { ForwardRef as ReactComponent };